import { ProjectStatus } from '../project';

export const TimeEntryStatusEnum = {
  PENDING_SCRUM: 'PENDING_SCRUM',
  PENDING_LEAD: 'PENDING_LEAD',
  PENDING_MANAGER: 'PENDING_MANAGER',
  EDIT_REQUESTED: 'EDIT_REQUESTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const

export type TimeEntryStatus = (typeof TimeEntryStatusEnum)[keyof typeof TimeEntryStatusEnum];

export interface TimeEntry {
  id: string;
  userId: string;
  projectId: string;
  phaseId: string;
  jobTitleId: string;
  date: string;
  fromHour: string;
  toHour: string;
  hours: number;
  notes: string;
  status: TimeEntryStatus;
  isDifferentJobTitle: boolean;
  rejectionReason?: string | null;
  /** Set on the caller's own entries (GET /time-entries/mine): can they still edit/delete it. */
  ownerEditable?: boolean;
  createdAt: string;
  updatedAt: string;
  user?: { id: string; name: string; email: string };
  project?: { id: string; name: string; billable: boolean; status?: ProjectStatus };
  phase?: { id: string; name: string };
  jobTitle?: { id: string; name: string };
}

export interface AuditLogEntry {
  id: string;
  action: string;
  targetTable: string;
  targetId: string;
  diff: Record<string, unknown>;
  createdAt: string;
  actor: { id: string; name: string; email: string };
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

